import styled from 'styled-components';

export const SaleInfoLabelsContainer = styled.div`
  display: grid;
  grid-row-gap: 12px;
`;

